import { render, staticRenderFns } from "./ItemsComponent.vue?vue&type=template&id=893d1430&"
import script from "./ItemsComponent.vue?vue&type=script&lang=js&"
export * from "./ItemsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports